import AuthClient from 'auth-client';

let authClient;
let currentSignInDomain;

const authHost =
  JSON.parse(process.env.VUE_APP_AUTH_HOST_MAPPING)[window.location.host] || 'signin-develop.atlatlvisual.io/api/v2';

export default function getAuthClient(signInDomain) {
  if (authClient && currentSignInDomain === signInDomain) {
    return authClient;
  }

  authClient = AuthClient.init(`https://${signInDomain}.${authHost}`);
  currentSignInDomain = signInDomain;
  return authClient;
}
